import { fb, insta, twiter, linkdin } from "../comman/images";

export const SocialMedia = [
    {icon: fb,link: "https://m.facebook.com/profile.php?id=100066239785375&_rdr"},
    {icon: insta,link: "https://www.instagram.com/softweirdo_solutions"},
    {icon: twiter,link: "https://mobile.twitter.com/softweirdos"},
    {icon: linkdin,link: "https://www.linkedin.com/company/softweirdo-solution/"}
]